export default (element) => {
    if (!element._quill) return false;

    if (element._quill.hasFocus()) return true;

    const tooltip = element.querySelector('.ql-tooltip');
    if (!tooltip) return false;

    const isToolbarHidden = tooltip.classList.contains('ql-hidden');
    return !isToolbarHidden;
};
